import _regeneratorRuntime from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { newTracker, trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import Cookies from 'js-cookie';
import { COOKIE_FOR_MOBILE_NAME, COOKIE_FOR_SESSION_NAME, EXPONEA, GB_LOCALES, LOCAL_ENVS, SNOWPLOW, AUTH_TOKEN_KEY, AUTH_TIME_DIFF_KEY, LAUNCH_DARKLY_CONSENT_STATUS, LAUNCH_DARKLY, US_LOCALES } from './constants';
export var isCSR = function isCSR() {
  return typeof window !== 'undefined';
};
export var isCOM = function isCOM() {
  var _a;

  return isCSR() && ((_a = window.location.hostname) === null || _a === void 0 ? void 0 : _a.endsWith('.com'));
};
export var isRaisinFrontend = function isRaisinFrontend() {
  var _a;

  return isCSR() && ((_a = window.location.pathname) === null || _a === void 0 ? void 0 : _a.includes('savingglobal'));
};

var detectMobileBrowser = function detectMobileBrowser() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(navigator.userAgent)) {
    return 'web-mobile';
  } else {
    return 'web';
  }
};

var getCurrentPlatform = function getCurrentPlatform() {
  var _location = location,
      pathname = _location.pathname,
      host = _location.host;
  var locale = pathname.split('/')[1].toLowerCase();
  return isCOM() ? "".concat(host, "/").concat(locale) : host;
};

export var getBrowsingApp = function getBrowsingApp() {
  return Cookies.get(COOKIE_FOR_MOBILE_NAME) ? 'app-webview' : detectMobileBrowser();
};
export var getCountryPlatform = function getCountryPlatform() {
  return getCurrentPlatform().replace('www.', '');
};
export var isLocalEnv = LOCAL_ENVS.some(function (env) {
  return isCSR() && env.test(window.location.host);
});
export var hasCookieForSession = function hasCookieForSession() {
  var cookie = Cookies.get(COOKIE_FOR_SESSION_NAME);
  return !!cookie && cookie === 'true';
};
export var initSnowplow = function initSnowplow(locale, defaultAppId) {
  var _a;

  var snowplowAppId = Cookies.get(COOKIE_FOR_MOBILE_NAME) === 'true' ? 'mobile_app' : SNOWPLOW.APP_IDS[getCurrentPlatform()];
  var appId = defaultAppId || snowplowAppId || SNOWPLOW.APP_IDS.default;
  newTracker(SNOWPLOW.TRACKER_ID, isLocalEnv ? SNOWPLOW.TEST_ENDPOINT : SNOWPLOW.PROD_ENDPOINT, {
    appId: appId,
    discoverRootDomain: false,
    cookieDomain: US_LOCALES.includes(locale.toLowerCase()) ? '.raisin.com' : window.location.hostname.replace('www', '')
  });
  var snowplowUnsentEvent = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem("snowplowOutQueue_".concat(SNOWPLOW.TRACKER_ID, "_post2")); // if there is an unsent event (which is stored in local storage)
  // send an empty event to trigger the unsent event

  if (snowplowUnsentEvent && JSON.parse(snowplowUnsentEvent).length > 0) {
    trackSelfDescribingEvent({
      event: {
        schema: SNOWPLOW.SCHEMA,
        data: {}
      }
    });
  }
};
export var initExponea = function initExponea(locale) {
  if (window === null || window === void 0 ? void 0 : window['exponea']) {
    return;
  }

  var exponeaToken;

  if (GB_LOCALES.includes(locale)) {
    exponeaToken = isLocalEnv ? EXPONEA.TEST_TOKEN.GB : EXPONEA.PROD_TOKEN.GB;
  } else if (US_LOCALES.includes(locale.toLowerCase())) {
    exponeaToken = isLocalEnv ? EXPONEA.TEST_TOKEN.US : EXPONEA.PROD_TOKEN.US;
  } else {
    exponeaToken = isLocalEnv ? EXPONEA.TEST_TOKEN.EU : EXPONEA.PROD_TOKEN.EU;
  }

  window.addEventListener('ucEvent', function (event) {
    // @ts-ignore
    createAndInjectExponeaSnippet(exponeaToken, event.detail[EXPONEA.USER_CENTRICS_CONSENT_NAME]);
  });
};

var createAndInjectExponeaSnippet = function createAndInjectExponeaSnippet(token) {
  var isConsentGiven = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var exponeaSnippet = document.createElement('script');
  exponeaSnippet.setAttribute('type', 'text/javascript');
  exponeaSnippet.setAttribute('data-usercentrics', 'Exponea');
  var trackConfig = '';

  if (isConsentGiven) {
    trackConfig = "track: {\n      visits: true,\n    },\n    spa_reloading: {\n      on_hash_change: false,\n      on_url_change: true,\n      visits: true,\n    },";
  } // If consent is given, we allow personalized web layers, otherwise we don't.


  var personalizedConfig = isConsentGiven ? 'personalized_weblayers: true,' : '';
  var consentWarning = isConsentGiven ? 'exponea.start();' : 'console.warn("Exponea Weblayer blocked due to missing consent");';
  exponeaSnippet.text = "!function(e,n,t,i,r,o){function s(e){if(\"number\"!=typeof e)return e;var n=new Date;return new Date(n.getTime()+1e3*e)}var a=4e3,c=\"xnpe_async_hide\";function p(e){return e.reduce((function(e,n){return e[n]=function(){e._.push([n.toString(),arguments])},e}),{_:[]})}function m(e,n,t){var i=t.createElement(n);i.src=e;var r=t.getElementsByTagName(n)[0];return r.parentNode.insertBefore(i,r),i}function u(e){return\"[object Date]\"===Object.prototype.toString.call(e)}o.target=o.target||\"https://api.exponea.com\",o.file_path=o.file_path||o.target+\"/js/exponea.min.js\",r[n]=p([\"anonymize\",\"initialize\",\"identify\",\"getSegments\",\"update\",\"track\",\"trackLink\",\"trackEnhancedEcommerce\",\"getHtml\",\"showHtml\",\"showBanner\",\"showWebLayer\",\"ping\",\"getAbTest\",\"loadDependency\",\"getRecommendation\",\"reloadWebLayers\",\"_preInitialize\",\"_initializeConfig\"]),r[n].notifications=p([\"isAvailable\",\"isSubscribed\",\"subscribe\",\"unsubscribe\"]),r[n].segments=p([\"subscribe\"]),r[n][\"snippetVersion\"]=\"v2.7.0\",function(e,n,t){e[n][\"_\"+t]={},e[n][\"_\"+t].nowFn=Date.now,e[n][\"_\"+t].snippetStartTime=e[n][\"_\"+t].nowFn()}(r,n,\"performance\"),function(e,n,t,i,r,o){e[r]={sdk:e[i],sdkObjectName:i,skipExperiments:!!t.new_experiments,sign:t.token+\"/\"+(o.exec(n.cookie)||[\"\",\"new\"])[1],path:t.target}}(r,e,o,n,i,RegExp(\"__exponea_etc__\"+\"=([\\w-]+)\")),function(e,n,t){m(e.file_path,n,t)}(o,t,e),function(e,n,t,i,r,o,p){if(e.new_experiments){!0===e.new_experiments&&(e.new_experiments={});var l,f=e.new_experiments.hide_class||c,_=e.new_experiments.timeout||a,g=encodeURIComponent(o.location.href.split(\"#\")[0]);e.cookies&&e.cookies.expires&&(\"number\"==typeof e.cookies.expires||u(e.cookies.expires)?l=s(e.cookies.expires):e.cookies.expires.tracking&&(\"number\"==typeof e.cookies.expires.tracking||u(e.cookies.expires.tracking))&&(l=s(e.cookies.expires.tracking))),l&&l<new Date&&(l=void 0);var d=e.target+\"/webxp/\"+n+\"/\"+o[t].sign+\"/modifications.min.js?http-referer=\"+g+\"&timeout=\"+_+\"ms\"+(l?\"&cookie-expires=\"+Math.floor(l.getTime()/1e3):\"\");\"sync\"===e.new_experiments.mode&&o.localStorage.getItem(\"__exponea__sync_modifications__\")?function(e,n,t,i,r){t[r][n]=\"<\"+n+' src=\"'+e+'\"></'+n+\">\",i.writeln(t[r][n]),i.writeln(\"<\"+n+\">!\"+r+\".init && document.writeln(\"+r+\".\"+n+'.replace(\"/'+n+'/\", \"/'+n+'-async/\").replace(\"><\", \" async><\"))</'+n+\">\")}(d,n,o,p,t):function(e,n,t,i,r,o,s,a){o.documentElement.classList.add(e);var c=m(t,i,o);function p(){r[a].init||m(t.replace(\"/\"+i+\"/\",\"/\"+i+\"-async/\"),i,o)}function u(){o.documentElement.classList.remove(e)}c.onload=p,c.onerror=p,r.setTimeout(u,n),r[s]._revealPage=u}(f,_,d,n,o,p,r,t)}}(o,t,i,0,n,r,e),function(e,n,t){var i;e[n]._initializeConfig(t),(null===(i=t.experimental)||void 0===i?void 0:i.non_personalized_weblayers)&&e[n]._preInitialize(t),e[n].start=function(i){i&&Object.keys(i).forEach((function(e){return t[e]=i[e]})),e[n].initialize(t)}}(r,n,o)}(document,\"exponea\",\"script\",\"webxpClient\",window,{\n    target: \"https://raisin-api.exponea.com\",\n    token: \"".concat(token, "\",\n    ").concat(trackConfig, "\n    ").concat(personalizedConfig, "\n    experimental: {\n        non_personalized_weblayers: true\n    }\n  });\n  ").concat(consentWarning, "\n  ");
  document.getElementsByTagName('head')[0].appendChild(exponeaSnippet);
};

var decodeJwt = function decodeJwt(jwt) {
  if (!jwt) {
    return;
  }

  try {
    var base64Url = jwt.split('.')[1];
    var modifiedBase64Url = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var uriValue = window.atob(modifiedBase64Url).split('').map(function (character) {
      var charCode = character.charCodeAt(0).toString(16);
      var hexValue = "00".concat(charCode).slice(-2);
      return "%".concat(hexValue);
    }).join('');
    var payload = decodeURIComponent(uriValue);
    return JSON.parse(payload);
  } catch (_err) {
    /* eslint-disable no-console */
    console.error('failed to decode jwt');
    throw _err;
  }
};

export var getAccessToken = function getAccessToken() {
  var auth = window === null || window === void 0 ? void 0 : window.localStorage.getItem(AUTH_TOKEN_KEY); // @ts-ignore

  return JSON.parse(auth).access_token;
};

var isAccessTokenExpired = function isAccessTokenExpired() {
  try {
    var auth = window === null || window === void 0 ? void 0 : window.localStorage.getItem(AUTH_TOKEN_KEY);
    var timeDelta = Number(window === null || window === void 0 ? void 0 : window.localStorage.getItem(AUTH_TIME_DIFF_KEY)) || 0;
    if (!auth) return true;
    var token = JSON.parse(auth).access_token;
    if (!token) return true;
    var jwt = decodeJwt(token);
    if (!jwt) return true;
    var exp = jwt.exp;
    var expiryEpoch = (exp + timeDelta) * 1000;
    return Number.isNaN(expiryEpoch) || Date.now() > expiryEpoch;
  } catch (error) {
    return true;
  }
};

export var getBACNumberFromJWT = function getBACNumberFromJWT() {
  try {
    var auth = window === null || window === void 0 ? void 0 : window.localStorage.getItem(AUTH_TOKEN_KEY); // @ts-ignore

    var token = JSON.parse(auth).access_token;
    var jwt = decodeJwt(token);

    if (!jwt) {
      return null;
    }

    var bacNumber = jwt.bac_number;
    return Array.isArray(bacNumber) ? bacNumber[0] : bacNumber;
  } catch (error) {
    return null;
  }
};
export var isCustomerLoggedIn = function isCustomerLoggedIn() {
  return !isAccessTokenExpired();
};
export var getLaunchDarklyConsent = function getLaunchDarklyConsent() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _a, _b, userCentrics, setConsentStatus, ucServices, launchDarkly, launchDarklyConsentStatus, onUcEvent;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return waitForUC_UI();

          case 3:
            userCentrics = _context.sent;

            // Helper function for setting consent status
            setConsentStatus = function setConsentStatus(status) {
              window === null || window === void 0 ? void 0 : window.localStorage.setItem(LAUNCH_DARKLY_CONSENT_STATUS, String(status));
            };

            if (userCentrics) {
              ucServices = (_a = userCentrics.getServicesBaseInfo) === null || _a === void 0 ? void 0 : _a.call(userCentrics);
              launchDarkly = ucServices === null || ucServices === void 0 ? void 0 : ucServices.find(function (service) {
                return (service === null || service === void 0 ? void 0 : service.id) === LAUNCH_DARKLY.CONSENT_ID;
              });
              launchDarklyConsentStatus = ((_b = launchDarkly === null || launchDarkly === void 0 ? void 0 : launchDarkly.consent) === null || _b === void 0 ? void 0 : _b.status) || false;
              setConsentStatus(launchDarklyConsentStatus);
            } // listen for consent change


            onUcEvent = function onUcEvent(event) {
              var customEvent = event;
              setConsentStatus(customEvent.detail.LaunchDarkly);
            };

            window.removeEventListener('ucEvent', onUcEvent);
            window.addEventListener('ucEvent', onUcEvent);
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            console.error('Error in getLaunchDarklyConsent:', _context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));
}; // checks if UC_UI is present

export var waitForUC_UI = function waitForUC_UI() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
  return new Promise(function (resolve, reject) {
    var start = Date.now();
    var timer = setInterval(function () {
      if (window === null || window === void 0 ? void 0 : window['UC_UI']) {
        clearInterval(timer);
        resolve(window['UC_UI']);
      } else if (Date.now() - start >= timeout) {
        clearInterval(timer);
        reject(new Error('UC_UI was not found within the timeout.'));
      }
    }, interval);
  });
};